import { useState } from "react";
import {C, withAlpha } from "../constants/theme";
import { Btn } from "./ui/Btn";

export function MarcaSelector({ value, onChange, marcas = [], onAddMarca }) {
  const [addMode, setAddMode] = useState(false); const [novaMarca, setNovaMarca] = useState("");
  return (
    <div>
      <label style={{ color:C.muted, fontSize:12, fontWeight:600, letterSpacing:1, display:"block", marginBottom:6 }}>MARCA</label>
      <div style={{ display:"flex", flexWrap:"wrap", gap:6, marginBottom:6 }}>
        {marcas.map(m => (
          <button type="button" key={m} aria-pressed={value===m} onClick={()=>onChange(m)} style={{ minHeight:36, padding:"4px 12px", borderRadius:10, cursor:"pointer", fontSize:12, fontWeight:600, background:value===m?withAlpha(C.accent2, "22"):C.panel, border:"1px solid "+(value===m?C.accent2:C.border), color:value===m?C.accent2:C.muted }}>{m}</button>
        ))}
        <button type="button" aria-expanded={addMode} onClick={()=>setAddMode(!addMode)} style={{ minHeight:36, padding:"4px 12px", borderRadius:10, cursor:"pointer", fontSize:12, fontWeight:600, background:C.panel, border:"1px dashed "+C.border, color:C.muted }}>+ Nova marca</button>
      </div>
      {addMode && (
        <div style={{ display:"flex", gap:8, alignItems:"center", flexWrap:"wrap" }}>
          <input aria-label="Nome da nova marca" value={novaMarca} onChange={e=>setNovaMarca(e.target.value)} placeholder="Nome da marca" style={{ background:C.card, border:"1px solid "+C.border, borderRadius:6, color:C.text, padding:"6px 10px", fontSize:13, outline:"none", flex:1, minWidth:100 }} />
          <Btn small color={C.accent2} onClick={()=>{ if(!novaMarca.trim()) return; onAddMarca(novaMarca.trim()); onChange(novaMarca.trim()); setNovaMarca(""); setAddMode(false); }}>Salvar</Btn>
          <Btn small outline onClick={()=>setAddMode(false)}>✕</Btn>
        </div>
      )}
    </div>
  );
}
